import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  border-radius: 0px;
  min-height: 850px;
`;

export default Wrapper;
